import SkeletonCard from './SkeletonCard'

const SkeletonTitle: React.FC = () => {
    return <SkeletonCard height="3rem" width="20rem" border="0.3rem" />
}

export default SkeletonTitle
